import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class IpoOtpValidateUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getIpoOtpValidate(req);
    }
}
export default IpoOtpValidateUseCase;
